module.exports = __webpack_public_path__ + "img/Recurso 25@300xt.5c8ee3c9.webp";